<template>
  <v-text-field
    :append-icon="icon"
    box
    :disabled="disabled"
    hide-details
    label="Expiration"
    mask="## / ##"
    type="tel"
    :required="required"
    return-masked-value
    :rules="rules"
    v-model="cardExpiration"
  ></v-text-field>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'fa-calendar'
    },
    required: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: () => {
        return [
          (v) => !!v || 'Expiration is required'
        ]
      }
    },
    value: String
  },

  computed: {
    cardExpiration: {
      get () {
        return this.value
      },
      set (cardExpiration) {
        this.$emit('input', cardExpiration)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/CardExpiration.vue